import React from 'react';

const GoverningLaw: React.FC = () => {
  return (
    <div className="space-y-4">
      <h4 className="text-lg font-semibold mb-2">Governing Law</h4>
      <p>These terms are governed by and construed in accordance with the laws of the State of California, United States, without regard to its conflict of law principles.</p>

      <h4 className="text-lg font-semibold mb-2 mt-6">Jurisdiction</h4>
      <ul className="list-disc pl-5 space-y-2">
        <li>Any disputes shall be resolved in the courts of California</li>
        <li>You consent to personal jurisdiction in California courts</li>
        <li>Exclusive venue for all disputes in California</li>
        <li>Small claims may be resolved in your local jurisdiction</li>
      </ul>

      <h4 className="text-lg font-semibold mb-2 mt-6">Dispute Resolution</h4>
      <ul className="list-disc pl-5 space-y-2">
        <li>Informal resolution attempted first through direct communication</li>
        <li>30-day cooling off period before legal action</li>
        <li>Written notice required for disputes, including:
          <ul className="list-disc pl-5 mt-2">
            <li>Detailed description of the dispute</li>
            <li>Proposed resolution</li>
            <li>Contact information for resolution</li>
          </ul>
        </li>
        <li>Class action waiver - all disputes must be resolved individually</li>
        <li>Arbitration procedures and cost sharing</li>
        <li>Small claims court option for eligible disputes</li>
      </ul>

      <h4 className="text-lg font-semibold mb-2 mt-6">International Users</h4>
      <ul className="list-disc pl-5 space-y-2">
        <li>Service primarily intended for US users</li>
        <li>International users subject to local laws</li>
        <li>Export control compliance required</li>
        <li>Language of proceedings will be English</li>
      </ul>

      <div className="bg-[#F4B6A1]/10 p-4 rounded-lg mt-6">
        <p className="text-sm text-gray-600">
          By using FeelHeard.me, you expressly agree to submit to the jurisdiction 
          of California courts for any disputes arising from these terms or your use 
          of the service.
        </p>
      </div>
    </div>
  );
};

export default GoverningLaw;